"use strict";

(function () {
  'use strict';

  function statusCharmsCtrl() {
    var vm = this;

    var _setCharmData = function _setCharmData() {
      if (vm.status === 'APPROVED') {
        vm.approvalText = 'Manager Approved!';
        vm.approvalClass = 'livestay-success-text';
      } else {
        vm.approvalText = 'Pending Manager Approval';
      }

      if (vm.balanceDue == 0) {
        vm.paymentText = 'Paid in Full!';
        vm.paymentClass = 'livestay-success-text';
      } else {
        vm.paymentText = 'Payment Required';
      }

      if (vm.agreementStatus) {
        vm.agreementText = 'Rental Agreement Received!';
        vm.agreementClass = 'livestay-success-text';
      } else {
        vm.agreementText = 'No Rental Agreement';
      }
    };

    this.$onInit = function () {
      _setCharmData();
    };
  }

  statusCharmsCtrl.$inject = [];
  angular.module('status-charms', []).component('statusCharms', {
    bindings: {
      status: '<',
      balanceDue: '<',
      agreementStatus: '<'
    },
    controller: statusCharmsCtrl,
    templateUrl: 'components/status-charms/status-charms.html'
  });
})();